import React, { useState } from 'react';
import {
  DownloadRounded as DownloadRoundedIcon,
  Delete as DeleteIcon,
  FlagRounded as FlagRoundedIcon,
  MoreVertRounded as MoreVertRoundedIcon,
} from '@mui/icons-material';
import { Fade, IconButton, Paper, Popper } from '@mui/material';
import { useClickOutside } from '@src/hooks/useClickOutSide';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { StyledMenuItem } from './index.style';

const MoreOptionBlock = ({
  onOpenDeleteDialog,
  onOpenReportDialog,
  onOpenMoreOptionBlock,
  openMoreOptionBlock,
  onDownloadBlockAudio,
  isDisabledDownloadBlockAudio,
  isDisabledDeleteBlock,
}) => {
  const { t } = useTranslation();

  const [anchorBlockOption, setAnchorBlockOption] = useState(null);
  const refClickOutSide = useClickOutside(() => onOpenMoreOptionBlock(false));

  const handleOpenDeleteDialog = () => {
    onOpenDeleteDialog();
  };

  return (
    <div ref={refClickOutSide}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setAnchorBlockOption(e.currentTarget);
          onOpenMoreOptionBlock(!openMoreOptionBlock);
        }}
        className="editor-toolbar-btn"
      >
        <MoreVertRoundedIcon
          style={{
            color: COLOR.darkBlue,
            opacity: 0.64,
          }}
        />
      </IconButton>
      <Popper
        transition
        style={{
          zIndex: 1000,
          width: '180px',
          color: '#1E164E',
          boxShadow: '0px 0px 20px 2px rgba(0, 0, 0, 0.1)',
        }}
        anchorEl={anchorBlockOption}
        open={openMoreOptionBlock}
        placement="bottom-end"
      >
        {({ TransitionProps }) => (
          <Fade
            style={{ padding: '4px 0px', boxShadow: 'none' }}
            {...TransitionProps}
            timeout={350}
          >
            <Paper>
              <StyledMenuItem
                disabled={isDisabledDownloadBlockAudio}
                key="downloadBlockAudio"
                onClick={onDownloadBlockAudio}
              >
                <span>
                  <IconButton className="option-btn" isDisableHover>
                    <DownloadRoundedIcon
                      style={{
                        color: COLOR.darkBlue,
                        fontSize: '24px',
                      }}
                    />
                  </IconButton>
                </span>
                <span>{t('download')}</span>
              </StyledMenuItem>

              <StyledMenuItem
                key="reportBlockAudio"
                onClick={onOpenReportDialog}
              >
                <span>
                  <IconButton className="option-btn" isDisableHover>
                    <FlagRoundedIcon
                      style={{
                        color: COLOR.darkBlue,
                        fontSize: '24px',
                      }}
                    />
                  </IconButton>
                </span>
                <span>{t('errorReport')}</span>
              </StyledMenuItem>

              <StyledMenuItem
                disabled={isDisabledDeleteBlock}
                key="handleOpenDeleteBlock"
                onClick={handleOpenDeleteDialog}
              >
                <IconButton className="option-btn" isDisableHover>
                  <DeleteIcon
                    style={{
                      color: '#FF3B30',
                      fontSize: '24px',
                    }}
                  />
                </IconButton>
                <span>{t('delete')}</span>
              </StyledMenuItem>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

export default MoreOptionBlock;
